var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feColorMatrix, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4, _feFlood3, _feComposite5, _feGaussianBlur3, _feOffset3, _feComposite6, _feFlood4, _feComposite7, _feGaussianBlur4, _feOffset4, _feComposite8, _feColorMatrix2, _feFlood5, _feComposite9, _feGaussianBlur5, _feOffset5, _feComposite0, _feFlood6, _feComposite1, _feGaussianBlur6, _feOffset6, _feComposite10, _feColorMatrix3, _feFlood7, _feComposite11, _feGaussianBlur7, _feOffset7, _feComposite12, _feFlood8, _feComposite13, _feGaussianBlur8, _feOffset8, _feComposite14, _feColorMatrix4, _feFlood9, _feComposite15, _feGaussianBlur9, _feOffset9, _feComposite16, _feFlood0, _feComposite17, _feGaussianBlur0, _feOffset0, _feComposite18, _feColorMatrix5, _feFlood1, _feComposite19, _feGaussianBlur1, _feOffset1, _feComposite20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetectionXLightWoSubtitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1490.3496mm",
    height: "438.87503mm",
    viewBox: "0 0 1490.3496 438.87503",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3652",
    x: -0.018001258,
    y: -0.117195,
    width: 1.0502535,
    height: 1.3501827
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood3642"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite3644"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 5,
    result: "blur",
    id: "feGaussianBlur3646"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    result: "offset",
    id: "feOffset3648"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite3650"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix45351"
  })), _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood45353",
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite45355",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur45357",
    in: "composite1",
    stdDeviation: 5,
    result: "blur"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset45359",
    dx: 10,
    dy: 14.7128,
    result: "offset"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite45361",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3682",
    x: -0.035214782,
    y: -0.031469796,
    width: 1.0968406,
    height: 1.0865419
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood3672"
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite3674"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 5,
    result: "blur",
    id: "feGaussianBlur3676"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    result: "offset",
    id: "feOffset3678"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite3680"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3652-3",
    x: -0.042366192,
    y: -0.68099552,
    width: 1.1182723,
    height: 2.9011123
  }, _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood3642-6"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite3644-7"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 5,
    result: "blur",
    id: "feGaussianBlur3646-5"
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    result: "offset",
    id: "feOffset3648-3"
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite3650-5"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix45437"
  })), _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood45439",
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite45441",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur45443",
    in: "composite1",
    stdDeviation: 5,
    result: "blur"
  })), _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset45445",
    dx: 10,
    dy: 10,
    result: "offset"
  })), _feComposite0 || (_feComposite0 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite45447",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3652-3-3",
    x: -0.11040501,
    y: -0.94357073,
    width: 1.3082139,
    height: 3.634135
  }, _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood3642-6-6"
  })), _feComposite1 || (_feComposite1 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite3644-7-7"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 5,
    result: "blur",
    id: "feGaussianBlur3646-5-5"
  })), _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    result: "offset",
    id: "feOffset3648-3-3"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite3650-5-5"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix45449"
  })), _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood45451",
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite45453",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur45455",
    in: "composite1",
    stdDeviation: 5,
    result: "blur"
  })), _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset45457",
    dx: 10,
    dy: 10,
    result: "offset"
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite45459",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3652-3-9",
    x: -0.082542516,
    y: -0.94357073,
    width: 1.2304312,
    height: 3.634135
  }, _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood3642-6-1"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite3644-7-2"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 5,
    result: "blur",
    id: "feGaussianBlur3646-5-7"
  })), _feOffset8 || (_feOffset8 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    result: "offset",
    id: "feOffset3648-3-0"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite3650-5-9"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix45461"
  })), _feFlood9 || (_feFlood9 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood45463",
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite45465",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur45467",
    in: "composite1",
    stdDeviation: 5,
    result: "blur"
  })), _feOffset9 || (_feOffset9 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset45469",
    dx: 10,
    dy: 10,
    result: "offset"
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite45471",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3652-3-2",
    x: -0.11376513,
    y: -0.94488126,
    width: 1.3175943,
    height: 3.6377935
  }, _feFlood0 || (_feFlood0 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood3642-6-61"
  })), _feComposite17 || (_feComposite17 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite3644-7-8"
  })), _feGaussianBlur0 || (_feGaussianBlur0 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 5,
    result: "blur",
    id: "feGaussianBlur3646-5-79"
  })), _feOffset0 || (_feOffset0 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    result: "offset",
    id: "feOffset3648-3-2"
  })), _feComposite18 || (_feComposite18 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite3650-5-0"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix45437-2"
  })), _feFlood1 || (_feFlood1 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood45439-3",
    floodOpacity: 0.498039,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite19 || (_feComposite19 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite45441-7",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur1 || (_feGaussianBlur1 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur45443-5",
    in: "composite1",
    stdDeviation: 5,
    result: "blur"
  })), _feOffset1 || (_feOffset1 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset45445-9",
    dx: 10,
    dy: 10,
    result: "offset"
  })), _feComposite20 || (_feComposite20 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite45447-2",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(1280.2876,2603.3584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1260",
    transform: "translate(499.29683,-100.96894)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9ccdd",
      strokeWidth: 1.85886
    },
    d: "m -611.07028,-2502.3894 c 6.3e-4,-1e-4 -6.3e-4,0 0,0 z",
    id: "path1274"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bceff",
      fillOpacity: 1,
      strokeWidth: 1.85886
    },
    d: "m -505.64683,-2314.1478 48.68333,-61.3833 46.0375,61.3833 z",
    id: "path1270"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00b9fe",
      fillOpacity: 1,
      strokeWidth: 1.85886
    },
    d: "m -459.60933,-2248.5311 c 0,0 -46.0375,-64.6262 -46.0375,-65.6167 h 94.72083 l 41.275,196.0563 z m 89.95833,-250.8252 h 80.41617 l -80.4165,123.8255 z",
    id: "path1268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#025d97",
      fillOpacity: 1,
      strokeWidth: 1.85886
    },
    d: "m -505.64683,-2314.1478 46.0375,65.6167 -170.3915,130.4396 c 34.90189,-61.7178 83.77973,-132.412 124.354,-196.0563 z m 135.996,-185.2083 -1.7e-4,123.825 h -87.3125 m -48.68333,61.3833 c 0,0 -30.07934,-40.2122 -63.6509,-90.3727 -33.57157,-50.1604 -60.70327,-94.8356 -60.70327,-94.8356 l 173.0375,123.825",
    id: "path1266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19244d",
      fillOpacity: 1,
      strokeWidth: 1.85886
    },
    d: "m -459.60933,-2248.5311 -84.4025,130.4396 h -85.989 c -1.7e-4,0 170.3915,-130.4396 170.3915,-130.4396 z m 48.68333,-65.6167 121.69117,196.1095 -80.41617,-0.053 z m -46.0375,-61.3833 c 29.18734,-0.7094 58.15793,-0.7137 87.3125,0 l -41.275,61.3804 z m -173.03733,-123.8252 h 85.989 l 87.04833,123.8252 c 0,0 -173.0375,-123.825 -173.03733,-123.8252 z",
    id: "path1262"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "detection",
    id: "text544",
    style: {
      fontSize: "265.957px",
      lineHeight: 1.25,
      fill: "#e6e6e6",
      strokeWidth: 1.38519
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1747.1377,-2145.5674 q -9.0425,0 -16.4893,-4.2553 -7.1808,-4.5213 -11.7021,-11.7021 -4.2553,-7.4468 -4.2553,-16.2234 v -89.8934 q 0,-8.7766 4.2553,-15.9575 4.5213,-7.4468 11.7021,-11.7021 7.4468,-4.5212 16.4893,-4.5212 h 102.9254 v -50.5319 h 21.8085 v 204.7869 h -124.7339 z m 0,-21.8085 h 92.5531 q 4.2553,0 7.1808,-2.9255 3.1915,-3.1915 3.1915,-7.4468 v -89.8934 q 0,-4.2554 -3.1915,-7.1809 -2.9255,-3.1915 -7.1808,-3.1915 h -92.5531 q -4.2553,0 -7.4467,3.1915 -2.9256,2.9255 -2.9256,7.1809 v 89.8934 q 0,4.2553 2.9256,7.4468 3.1914,2.9255 7.4467,2.9255 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1567.8828,-2145.5674 q -8.7766,0 -16.2234,-4.2553 -7.1808,-4.5213 -11.7021,-11.7021 -4.2553,-7.4468 -4.2553,-16.2234 v -89.8934 q 0,-8.7766 4.2553,-15.9575 4.5213,-7.4468 11.7021,-11.7021 7.4468,-4.5212 16.2234,-4.5212 h 92.553 q 9.0426,0 16.2234,4.5212 7.4468,4.2553 11.7021,11.7021 4.5213,7.1809 4.5213,15.9575 v 55.8509 h -135.3721 v 34.0425 q 0,4.2553 2.9255,7.4468 3.1915,2.9255 7.4468,2.9255 h 124.9998 v 21.8085 h -124.9998 z m -10.3723,-88.0318 h 113.2977 v -34.0424 q 0,-4.2554 -3.1915,-7.1809 -2.9256,-3.1915 -7.1809,-3.1915 h -92.553 q -4.2553,0 -7.4468,3.1915 -2.9255,2.9255 -2.9255,7.1809 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1383.3088,-2145.5674 q -9.0425,0 -16.4893,-4.2553 -7.1809,-4.5213 -11.4362,-11.7021 -4.2553,-7.4468 -4.2553,-16.2234 v -172.6061 h 21.8085 v 50.5319 h 66.7552 v 21.8084 h -66.7552 v 100.2658 q 0,4.2553 2.9255,7.4468 3.1915,2.9255 7.4468,2.9255 h 56.3829 v 21.8085 h -56.3829 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1274.7984,-2145.5674 q -8.7765,0 -16.2233,-4.2553 -7.1809,-4.5213 -11.7021,-11.7021 -4.2554,-7.4468 -4.2554,-16.2234 v -89.8934 q 0,-8.7766 4.2554,-15.9575 4.5212,-7.4468 11.7021,-11.7021 7.4468,-4.5212 16.2233,-4.5212 h 92.5531 q 9.0425,0 16.2233,4.5212 7.4468,4.2553 11.7022,11.7021 4.5212,7.1809 4.5212,15.9575 v 55.8509 h -135.3721 v 34.0425 q 0,4.2553 2.9255,7.4468 3.1915,2.9255 7.4468,2.9255 h 124.9998 v 21.8085 h -124.9998 z m -10.3723,-88.0318 h 113.2977 v -34.0424 q 0,-4.2554 -3.1915,-7.1809 -2.9255,-3.1915 -7.1808,-3.1915 h -92.5531 q -4.2553,0 -7.4468,3.1915 -2.9255,2.9255 -2.9255,7.1809 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1096.0755,-2145.5674 q -8.7766,0 -16.2234,-4.2553 -7.1808,-4.5213 -11.7021,-11.7021 -4.2553,-7.4468 -4.2553,-16.2234 v -89.8934 q 0,-8.7766 4.2553,-15.9575 4.5213,-7.4468 11.7021,-11.7021 7.4468,-4.5212 16.2234,-4.5212 h 124.46785 v 21.8084 h -124.46785 q -4.2553,0 -7.4468,3.1915 -2.9255,2.9255 -2.9255,7.1809 v 89.8934 q 0,4.2553 2.9255,7.4468 3.1915,2.9255 7.4468,2.9255 h 124.99977 v 21.8085 h -124.99977 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path906"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -917.35294,-2145.5674 q -9.04254,0 -16.48933,-4.2553 -7.18084,-4.5213 -11.43615,-11.7021 -4.25531,-7.4468 -4.25531,-16.2234 v -172.6061 h 21.80847 v 50.5319 h 66.75521 v 21.8084 h -66.75521 v 100.2658 q 0,4.2553 2.92553,7.4468 3.19148,2.9255 7.44679,2.9255 h 56.38289 v 21.8085 h -56.38289 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -839.4278,-2145.5674 v 0 -154.255 h 21.80847 v 154.255 z m 0,-182.9784 v 0 -21.8085 h 21.80847 v 21.8085 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -752.19436,-2145.5674 q -8.77658,0 -16.22338,-4.2553 -7.18084,-4.5213 -11.70211,-11.7021 -4.25531,-7.4468 -4.25531,-16.2234 v -89.8934 q 0,-8.7766 4.25531,-15.9575 4.52127,-7.4468 11.70211,-11.7021 7.4468,-4.5212 16.22338,-4.5212 h 92.55304 q 9.04253,0 16.22337,4.5212 7.4468,4.2553 11.70211,11.7021 4.52127,7.1809 4.52127,15.9575 v 89.8934 q 0,8.7766 -4.52127,16.2234 -4.25531,7.1808 -11.70211,11.7021 -7.18084,4.2553 -16.22337,4.2553 h -92.55304 z m 0,-21.8085 h 92.55304 q 4.25531,0 7.18083,-2.9255 3.19149,-3.1915 3.19149,-7.4468 v -89.8934 q 0,-4.2554 -3.19149,-7.1809 -2.92552,-3.1915 -7.18083,-3.1915 h -92.55304 q -4.25531,0 -7.4468,3.1915 -2.92552,2.9255 -2.92552,7.1809 v 89.8934 q 0,4.2553 2.92552,7.4468 3.19149,2.9255 7.4468,2.9255 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -603.52492,-2145.5674 v 0 -154.255 h 124.99979 q 8.77658,0 15.95742,4.5212 7.4468,4.2553 11.70211,11.7021 4.52127,7.1809 4.52127,15.9575 v 122.0742 h -21.80848 v -122.0742 q 0,-4.2554 -3.19148,-7.1809 -2.92553,-3.1915 -7.18084,-3.1915 h -92.55303 q -4.25532,0 -7.4468,3.1915 -3.19148,2.9255 -3.19148,7.1809 v 122.0742 z",
    style: {
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron"
    },
    id: "path914"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectionXLightWoSubtitle);
export default __webpack_public_path__ + "static/media/detection-x_light_wo_subtitle.9bee086372c29c70f8b2cc7f016d00ae.svg";
export { ForwardRef as ReactComponent };